import React from 'react';

// import { Container } from './styles';

const CustomizedMarker = ({ auditoriaDTO }) => {
  let item = {
    ADD: {
      icon: "pi pi-plus-circle",
      style: {
        color: "#005494",
        fontSize: "2rem",
      },
    },
    MOD: {
      icon: "pi pi-refresh",
      style: {
        color: "#FF9E02",
        fontSize: "2rem",
      },
    },
  };

  return (
    <span className="custom-marker shadow-1">
      <i className={item[auditoriaDTO.revtype].icon} style={item[auditoriaDTO.revtype].style}></i>
    </span>
  );
};

export default CustomizedMarker;